"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrentRefinements = CurrentRefinements;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _cx = require("./lib/cx");

var _isModifierClick = require("./lib/isModifierClick");

var _excluded = ["classNames", "items", "onRemove", "hasRefinements"];

function CurrentRefinements(_ref) {
  var _ref$classNames = _ref.classNames,
      classNames = _ref$classNames === void 0 ? {} : _ref$classNames,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$onRemove = _ref.onRemove,
      onRemove = _ref$onRemove === void 0 ? function () {} : _ref$onRemove,
      _ref$hasRefinements = _ref.hasRefinements,
      hasRefinements = _ref$hasRefinements === void 0 ? false : _ref$hasRefinements,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, props, {
    className: (0, _cx.cx)('ais-CurrentRefinements', classNames.root, !hasRefinements && (0, _cx.cx)('ais-CurrentRefinements--noRefinement', classNames.noRefinementRoot), props.className)
  }), /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _cx.cx)('ais-CurrentRefinements-list', classNames.list, !hasRefinements && (0, _cx.cx)('ais-CurrentRefinements-list--noRefinement', classNames.noRefinementList))
  }, items.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: [item.indexName, item.label].join('/'),
      className: (0, _cx.cx)('ais-CurrentRefinements-item', classNames.item)
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _cx.cx)('ais-CurrentRefinements-label', classNames.label)
    }, item.label, ":"), item.refinements.map(function (refinement) {
      return /*#__PURE__*/_react.default.createElement("span", {
        key: refinement.label,
        className: (0, _cx.cx)('ais-CurrentRefinements-category', classNames.category)
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _cx.cx)('ais-CurrentRefinements-categoryLabel', classNames.categoryLabel)
      }, refinement.label), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: function onClick(event) {
          if ((0, _isModifierClick.isModifierClick)(event)) {
            return;
          }

          onRemove(refinement);
        },
        className: (0, _cx.cx)('ais-CurrentRefinements-delete', classNames.delete)
      }, "\u2715"));
    }));
  })));
}